var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Carousel',{attrs:{"perPageCustom":[
    [320, 1],
    [768, 1],
    [1024, 2] ],"paginationEnabled":true,"paginationActiveColor":"#3A4BE4","paginationPadding":_vm.paginationPadding,"paginationSize":_vm.paginationSize,"autoplay":""}},_vm._l((_vm.loadData),function(slide,i){return _c('Slide',{key:i},[_c('div',{staticStyle:{"margin":"0 12px"}},[_c('a',{attrs:{"href":slide.link}},[_c('img',{staticClass:"slider-item",attrs:{"src":slide.image}})])])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }